// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1JrRd","infoBtn":"quickbooks_infoBtn__Q7SGb","formBox":"quickbooks_formBox__An18F","formFooter":"quickbooks_formFooter__2inU8"};